import { flow, Instance, SnapshotIn, types } from 'mobx-state-tree';

import { enrollmentResource } from '../../infrastructure/http/EnrollmentResource';
import { ProductKit } from '../order-selection/starter-kit-selection/model/ProductKit';
import { ProductInfoStore } from '../product-info/model/ProductInfoStore';
import { getRootStore } from '../root/RootStoreUtils';
import { EnrollmentOrderItem } from '../order-selection/starter-kit-selection/model/EnrollmentOrderItem';
import { ItemInfoStore } from '../product-info/model/ItemInfoStore';
import { VoucherDetails } from './VoucherDetails';


export const EnrollmentOrderInfoStore = types
  .model('EnrollmentOrderInfoStore', {
    starterKit: types.maybe(types.late(() => ProductKit)),
    additionalItems: types.optional(types.array(EnrollmentOrderItem), []),
    unavailableAdditionalItems: types.optional(types.array(EnrollmentOrderItem), []),
    erKit: types.maybe(types.late(() => ProductKit)),
    erAdditionalItems: types.optional(types.array(EnrollmentOrderItem), []),
    isEnrollingInEr: types.optional(types.boolean, false),
    usePremiumStarterKitAsErOrder: types.optional(types.boolean, false),
    usePremiumStarterKitAsMeoOrder: types.optional(types.boolean, false),
    showProductModal: types.optional(types.boolean, false),
    showInfoModal: types.optional(types.boolean, false),
    productInfo: types.maybe(ProductInfoStore),
    itemInfo: types.maybe(ItemInfoStore),
    minimumErPv: types.number,
    starterKitPv: types.number,
    additionalItemsTotalPv: types.number,
    erAdditionalItemsTotalPv: types.number,
    voucherCodeDetails:types.optional(types.maybe(VoucherDetails),{createdCustomerId:'',currency:'',isExpired:false,amount:0,code:0})
  })
  .views(self => ({
    get currentPv(): number {
      return self.starterKitPv + self.additionalItemsTotalPv || 0;
    },
    get isMinimumErPvReached(): boolean {
      return this.currentPv >= self.minimumErPv;
    },
    get totalERPv(): boolean {
      const kitPv = self.erKit?.pointValue || 0;
      const additionalPv = self.erAdditionalItemsTotalPv || 0;
      const totalPv = kitPv + additionalPv || 0;
      console.log("totalpv",totalPv)
      return totalPv >= self.minimumErPv;
    }
  }))
  .actions(self => {
    return {
      showProductInfo: flow(function* showProductInfo(kit: any): any {
        const { locale } = getRootStore(self).localeManager.language;
        const partNumber = kit.upgradeComponent ? kit.upgradeComponent.partNumber : kit.partNumber;
        const response = yield enrollmentResource.get<SnapshotIn<typeof ProductInfoStore>>(
          `/product-info/${locale}/${partNumber}`
        );
        self.productInfo = ProductInfoStore.create({
          kit: kit.itemId,
          ...response.data
        });
        self.showProductModal = true;
      }),
      showItemInfo: flow(function* showItemInfo(item: any): any {
        const { locale } = getRootStore(self).localeManager.language;
        const partNumber = item.partNumber;
        const response = yield enrollmentResource.get<SnapshotIn<typeof ItemInfoStore>>(
          `/product-info/${locale}/${partNumber}`
        );
        self.itemInfo = ItemInfoStore.create({
          ...response.data
        });
        self.itemInfo.pointValue = item.pointValue;
        self.showInfoModal = true;
      }),
      hideProductInfo: () => {
        self.productInfo = undefined;
        self.showProductModal = false;
      },
      hideItemInfo: () => {
        self.itemInfo = undefined;
        self.showInfoModal = false;
      }
    };
  });

export type EnrollmentOrderInfoStore = Instance<typeof EnrollmentOrderInfoStore>;
